import { render, staticRenderFns } from "./TablaNuevaSiniestralidadProduccionPorSucursal.vue?vue&type=template&id=2851cc56"
import script from "./TablaNuevaSiniestralidadProduccionPorSucursal.vue?vue&type=script&lang=js"
export * from "./TablaNuevaSiniestralidadProduccionPorSucursal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports